import {BulletinHoursListIdsRequest} from '../../../../../infrastructure/remote/sacmi/dto/request/BulletinHoursListIdsRequest';
import {SummaryListExportExcelResponse} from '../../../../../infrastructure/remote/sacmi/dto/response/SummaryListExportExcelResponse';
import {ApiClientResponse} from '../../../../../infrastructure/remote/sacmi/dto/ApiClient';
import {SummaryRepository} from '../../../domain/repository/SummaryRepository';
import ExportSummaryListExcelDataMapper from './mapper/request/ExportSummaryListExcelDataMapper';

export class ApiSummaryRepository implements SummaryRepository {
    constructor(private apiClient: ApiClientResponse) {}

    public async exportExcel(filters: BulletinHoursListIdsRequest): Promise<SummaryListExportExcelResponse> {
        try {
            return await this.apiClient.summaryListExportExcel(
                ExportSummaryListExcelDataMapper.fromDomain(filters)
            );
        } catch (error) {
            return Promise.reject(error);
        }
    }
}
